module.exports = __webpack_public_path__ + "img/send-solution-thanks.83bd7765.svg";